export default function WaveAnimation() {
  return null; // Removing the wave animation for a simpler design
}